<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null" :disabledValid="true">
    <div class="question-box mt-40 pb-30">
      <div class="question-box-intro-two mb-30">
        <h3>Keep up to date?</h3>
      </div>

      <p>
        We'd like you to provide information on the latest news
        and promotions. You can let us know at any time if you change
        your mind.
      </p>

      <p><strong>Would you like us to keep in touch?</strong></p>
      <InputRadio
          v-model="data"
          :options="booleanYesNo"
          :db="db"
          :args="args"
          :skipped="skipped"
          @skipped="skipped=$event"
          @serverErrors="serverErrors=$event"
          @jsErrors="jsErrors=$event"
          ref="input"
      />
    </div>
  </QuestionBase>
</template>

<script>
import {httpQuestionnaire} from "@/services";
import {questionLoadHelpers} from "../../../helpers/questionLoadHelpers";
import { general } from "../../../options/general";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'MarketingConsent',
  mixins: [questionLoadHelpers, general],
  components: {
    InputRadio,
    QuestionBase
  },
  mounted () {
    // if there is a marketing date then set consent to true
    if (this.consentDate && this.data === null) {
      this.$refs.input.data = true
    }
  },
  props: {
    value: {
      type: Boolean,
      required: false
    },
    consentDate: {
      type: String,
      required: false
    },
    saveLocation: {
      type: String,
      default: 'client_client'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title:  null,
        subTitle:  null,
        tip: null,
      },
      db: {
        saveLocation: this.saveLocation,
        saveField: 'profileMarketingConsent',
        callbackFunction: this.setDate
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  },
  methods: {
    setDate () {
      // set marketing date to now if given consent
      let data = {
        profileMarketingConsentDate: this.data ? new Date() : null
      }
      httpQuestionnaire.patch(this.saveLocation, data).then(
          response => {
            console.log(response.data)
          }
      ).catch(
          error => {
            console.log(error)
          }
      )
    }
  }
}
</script>
